import { render } from "./SolutionDetails.vue?vue&type=template&id=fd3d619a"
import script from "./SolutionDetails.vue?vue&type=script&lang=js"
export * from "./SolutionDetails.vue?vue&type=script&lang=js"

import "./SolutionDetails.vue?vue&type=style&index=0&id=fd3d619a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__